exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".two-columns{display:flex;justify-content:space-between;width:800px;margin:0 auto;padding:20px 0}@media screen and (max-width:768px){.two-columns{display:block;width:auto;padding:20px 15px}}.two-columns__main{width:calc(100% - 230px)}@media screen and (max-width:768px){.two-columns__main{width:auto}}.two-columns__side{width:210px}@media screen and (max-width:768px){.two-columns__side{width:auto}}.grey-select-box{border:1px solid #d8d8d8;width:100%;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01eb81a6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 230
// module chunks = 0